const GOLD = '#D4AF37'

export function BrandMark({ size = 22 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={Math.round(size * 1.15)}
      viewBox="0 0 64 72"
      fill="none"
      aria-hidden
    >
      <rect x="8" y="8" width="12" height="56" fill="currentColor" />
      <rect x="8" y="8" width="48" height="11" fill="currentColor" />
      <rect x="22" y="53" width="34" height="11" fill="currentColor" />
      <rect x="28" y="32" width="11" height="11" fill="currentColor" />
      <rect x="43" y="32" width="11" height="11" fill={GOLD} />
    </svg>
  )
}

export function BrandLockup({ compact = false }: { compact?: boolean }) {
  return (
    <span className={compact ? 'brand-lockup brand-lockup--compact' : 'brand-lockup'}>
      <BrandMark size={compact ? 20 : 24} />
      <span className="brand-word">
        <span className="brand-eudokia">EUDOKIA</span>
        <span className="brand-legal">LEGAL</span>
      </span>
    </span>
  )
}
